import React from "react"
import { Route } from "react-router-dom"
import UnAuthGuard from "../guards/unAuthGuards"
import Login from "../pages/Login/login"

const UnAuthRoutes = [
    <Route key="Login" path="/login" element={<UnAuthGuard component={<Login />} />} ></Route>,
]

export default UnAuthRoutes